/** Workspace specific banners */
export const WORKSPACE_SPECIFIC_BANNERS = [{
  title: "Payment Overdue",
  text: "Please contact administrator to avoid service interruption.",
  variant: "error",
  ids: [
    // Paste here the IDs of workspaces that need to see the payment overdue banner
  ]
}];